export default class ReceiverSelector {
  public static selectReceivedCount(state: ReduxState) {
    return state.receiver.receivedCount;
  }

  public static selectReceivedByTeamCount(state: ReduxState) {
    return state.receiver.byTeamCount;
  }
}
